import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getPSProjectList(params) {
  return request({
    url: `${v2Host}/ps/project/list`,
    method: 'get',
    params,
  })
}

export function getPSProjectInfo(params) {
  return request({
    url: `${v2Host}/ps/project/info`,
    method: 'get',
    params,
  })
}

export function getPSProjectPreview(params) {
  return request({
    url: `${v2Host}/ps/project/preview`,
    method: 'get',
    params,
  })
}

export function deletePSProject(data) {
  return request({
    url: `${v2Host}/ps/project/delete`,
    method: 'post',
    data,
  })
}

export function exportPSProjectBasic(data) {
  return request({
    url: `${v2Host}/ps/project/export-basic`,
    method: 'post',
    data,
  })
}

export function exportPSProjectExcel(params) {
  return request({
    url: `${v2Host}/ps/project/export`,
    method: 'get',
    params,
  })
}

export function createPSProject(data) {
  return request({
    url: `${v2Host}/ps/project/create`,
    method: 'post',
    data,
  })
}

export function copyPSProject(data) {
  return request({
    url: `${v2Host}/ps/project/copy`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}
